import React from "react";
import { motion } from "framer-motion";
import { CURRICULUM_PILLARS } from "../data/content";
import { ShapeCircle } from "./brand/Shapes";
import CambridgeLogo from "./brand/CambridgeLogo";

const colorMap = {
  cornflower: "#648DE5",
  lime: "#C6D947",
  teal: "#5BC4B8",
  turquoise: "#3AB0D6",
};

export default function Curriculum() {
  return (
    <section
      id="curriculum"
      className="relative py-14 md:py-28 bg-[#FAFAF5] overflow-hidden"
      data-testid="curriculum-section"
    >
      <ShapeCircle
        size={220}
        color="#648DE5"
        className="absolute -top-20 left-[45%] opacity-10 hidden md:block"
      />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-6 md:gap-10 items-end mb-10 md:mb-16">
          <div className="lg:col-span-7">
            <CambridgeLogo height={48} className="mb-5" testid="curriculum-cambridge-logo" />
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.8 }}
              className="font-display text-[#0F1B47] text-[32px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-semibold"
            >
              Six learning pillars.
              <br />
              One extraordinary
              <br />
              <span className="italic font-normal">foundation</span>.
            </motion.h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#4A5568] text-lg leading-relaxed font-light">
              Internationally benchmarked. Locally rooted. The Cambridge Early Years
              framework shapes our days in six gentle pillars — each deliberately woven
              into play, story and conversation.
            </p>
          </div>
        </div>

        {/* Bento grid of pillars */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CURRICULUM_PILLARS.map((pillar, i) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: i * 0.07 }}
              className="bento-card relative bg-[#FAFAF5] rounded-3xl p-6 md:p-8 overflow-hidden"
              data-testid={`curriculum-pillar-${i}`}
            >
              <div
                className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-20"
                style={{ background: colorMap[pillar.color] }}
              />
              <div
                className="relative font-display text-4xl md:text-5xl font-semibold mb-2 md:mb-3"
                style={{ color: colorMap[pillar.color] }}
              >
                0{i + 1}
              </div>
              <h3 className="relative font-display text-xl md:text-2xl text-[#0F1B47] font-medium mb-2 md:mb-3">
                {pillar.title}
              </h3>
              <p className="relative text-[#4A5568] text-sm leading-relaxed font-light">
                {pillar.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
